import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { lccstate } from '@holmescorp/lcc-state';
import { scroll } from '@holmescorp/middleware';
import css from '../css/pagegroup.m.css';
const icache = createICacheMiddleware();
const factory = create({ icache, theme, lccstate, scroll }).properties();
export const LPPageGroup = factory(({ properties, middleware: { icache, theme, lccstate, scroll } }) => {
    const render_kids = (kids) => {
        return kids.map((kid) => {
            const { widget } = kid;
            const params = { ...kid };
            delete params['widget'];
            return w(widget, { ...params });
        });
    };
    const render_view = (view) => {
        return [w(view.widget, { ...view.params })];
    };
    const { classes = [], name = 'lppagegroupdefault', element = 'div', kids = [] } = properties();
    const view = lccstate.get(lccstate.path('view'));
    const themeCss = theme.classes(css);
    if (view && view.widget && !icache.get('scrolled')) {
        scroll.scrollIntoView('lppagegroup-wrapper');
        icache.set('scrolled', true);
    }
    else if (!view) {
        icache.set('scrolled', false, false);
    }
    return v('div', { key: 'lppagegroup-wrapper' }, [
        v(element, { classes: [themeCss.root, ...classes], key: name, xqa: `lppagegroup ${name}` }, view && view.widget ? render_view(view) : render_kids(kids))
    ]);
});
export default LPPageGroup;
